export const FETCH_METRIC_INVOICES = 'FETCH_METRIC_INVOICES';
export const FETCH_METRIC_USERS = 'FETCH_METRIC_USERS';
export const FETCH_METRIC_GENERAL = 'FETCH_METRIC_GENERAL';
export const FETCH_METRIC_ORDERS = 'FETCH_METRIC_ORDERS';
export const FETCH_METRIC_COURSES = 'FETCH_METRIC_COURSES';
export const FETCH_METRIC_USER_ORDERS = 'FETCH_METRIC_USER_ORDERS';
